import React, {useState, useEffect, useContext} from 'react';
import './PgePlanning.scss';
import {I18nContext} from '../../contexts/i18nContext';
import {ProjectsContext} from '../../contexts/projectsContext';
import {SelectionsContext} from '../../contexts/selectionsContext';
import {Loader, LoaderFullPage} from '../_common';
import {getOptionsList} from "../../helpers/helpers";
import PgePlanningItem from './PgePlanningItem';

const PgePlanning = () => {
  const { t } = useContext(I18nContext);
  const {
    pending,
    pgeProjects,
    getPgeProjects,
    addProjectPending
  } = useContext(ProjectsContext);
  const { getSelections, selections } = useContext(SelectionsContext);
  const [projectsToPlan, setProjectsToPlan] = useState([]);

  const cableDiameterOptions = getOptionsList(selections, 'PGE przekroje kabli');
  const oversightUserOptions = getOptionsList(selections, 'Elektromonterzy');
  const connectionPointOptions = getOptionsList(selections, 'PGE punkty przyłączeniowe');

  useEffect(() => {
    getSelections();
  }, []);

  useEffect(() => {
    getPgeProjects(99999, 0, {sortField: 'constructionDate', order: 'ASC'}, {});
  }, []);

  useEffect(() => {
    setProjectsToPlan(pgeProjects.filter(project => !!project.toBePlanned && !project.archived));
  }, [pgeProjects]);

  return (
    <div className='PgePlanning'>
      {!!addProjectPending && (
        <LoaderFullPage  />
      )}
      <div className='planningHeader'>
        <div className='planningHeaderCell'>
          {t('construction date')}
        </div>
        <div className='planningHeaderCell'>
          {t('investment address')}
        </div>
        <div className='planningHeaderCell'>
          {t('staking')}
        </div>
        <div className='planningHeaderCell--large'>
          {t('materials')}
        </div>
        <div className='planningHeaderCell'>
          {t('construction crew')}
        </div>
        <div className='planningHeaderCell'>
          {t('leaves')}
        </div>
        <div className='planningHeaderCell'>
          {t('remarks') + " - " + t('construction work')}
        </div>
        <div className='planningHeaderCell'>
          {t('remarks') + " - " + t('rights to the location')}
        </div>
        <div className='planningHeaderCell'>
          {t('order cost')}
        </div>
        <div className='planningHeaderActionCell'/>
      </div>
      <div className='planningTable'>
        {!!pending && (
          <div className='loaderWrapper'><Loader/></div>
        )}
        {!pending && projectsToPlan
          .filter(project => !!project?.implementation?.construction?.constructionDate)
          .map(project => (
            <PgePlanningItem
              key={project.id}
              project={project}
              refreshProjects={() =>
                getPgeProjects(
                  99999, 0, {sortField: 'constructionDate', order: 'ASC'}, {}
                )
              }
              cableDiameterOptions={cableDiameterOptions}
              oversightUserOptions={oversightUserOptions}
              connectionPointOptions={connectionPointOptions}
            />
          ))
        }
        {!pending && projectsToPlan
          .filter(project => !project?.implementation?.construction?.constructionDate)
          .map(project => (
            <PgePlanningItem
              key={project.id}
              project={project}
              refreshProjects={() =>
                getPgeProjects(
                  99999, 0, {sortField: 'constructionDate', order: 'ASC'}, {}
                )
              }
              cableDiameterOptions={cableDiameterOptions}
              oversightUserOptions={oversightUserOptions}
              connectionPointOptions={connectionPointOptions}
            />
          ))
        }
      </div>

    </div>
  );
};

export default PgePlanning;
